import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getQuestionStore = (state: RootState) => state.questionStore;
const getQuestions = createSelector(getQuestionStore, (state) => state.questions);
const getQuestion = createSelector(getQuestionStore, (state) => state.question);
const getQuestionsByDepartment = createSelector(getQuestionStore, (state) => state.questionsByDepartment);

export { getQuestions, getQuestion, getQuestionsByDepartment };
